/* eslint-disable import/prefer-default-export */
export const DEVTOOLBAR_ALLOWED_ENVIRONMENTS = ['pl-test', 'mx-test', 'test'];